import { Icon, IconName } from '@openeducation/oe-rn-components';
import React from 'react';
import {
  StyleProp,
  TextStyle,
  TouchableHighlight,
  View,
  ViewStyle,
} from 'react-native';

import { LessonIndexItemNumber } from './lesson-index-item-number';
import styles from './lesson-index-item.style';
import { useColors } from '../../../hooks/lesson-player.context';
import ThemedText2 from '../../themed-text-2';
import { LessonSlideStatus } from '../lesson-slide-status.enum';

interface LessonIndexItemProps {
  text: string;
  onPress: () => void;
  index: number;
  status: LessonSlideStatus;
  isCurrent?: boolean;
}

export function LessonIndexItem({
  text,
  onPress,
  index,
  isCurrent = false,
  status = LessonSlideStatus.LOCKED,
}: LessonIndexItemProps) {
  const colors = useColors();

  let underlayColor = colors.primaryLight;
  let iconName: IconName = 'chevron-right';
  let iconColor = colors.silverGray;
  const containerStyle: StyleProp<ViewStyle> = [styles.container];
  const textStyle: StyleProp<TextStyle> = [styles.text];

  switch (status) {
    case LessonSlideStatus.COMPLETED:
      textStyle.push({ color: colors.silverGray });
      break;
    case LessonSlideStatus.NEXT:
      containerStyle.push({ backgroundColor: colors.primaryLight });
      underlayColor = colors.primary;
      break;
    default:
      underlayColor = 'transparent';
      textStyle.push({ color: colors.lightSilverGray });
      iconName = 'lock';
      iconColor = colors.lightSilverGray;
  }

  if (isCurrent) {
    textStyle.push({ color: colors.primary });
    iconColor = colors.primary;
  }

  return (
    <TouchableHighlight underlayColor={underlayColor} onPress={onPress}>
      <View style={containerStyle}>
        <View
          style={[styles.innerContainer, { borderColor: colors.grayLight }]}
        >
          <LessonIndexItemNumber
            number={index + 1}
            isCurrent={isCurrent}
            status={status}
          />

          <ThemedText2 fontWeightStyle="bold" style={textStyle}>
            {text}
          </ThemedText2>

          <View style={styles.iconContainer}>
            <Icon type="solid" color={iconColor} size={18} name={iconName} />
          </View>
        </View>
      </View>
    </TouchableHighlight>
  );
}
